import { createAction, handleActions } from 'redux-actions';
import api from '../../api';

const initialState = {
	fetching: false,
	passwordResetRequested: false,
	passwordResetRequestFailed: false,
	passwordChanged: false,
	passwordChangeFailed: false,
};

// ------------------------------------
// Constants
// ------------------------------------
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE';

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const REQUEST_PASSWORD_RESET_PENDING = 'REQUEST_PASSWORD_RESET_PENDING';
export const REQUEST_PASSWORD_RESET_SUCCESS = 'REQUEST_PASSWORD_RESET_SUCCESS';
export const REQUEST_PASSWORD_RESET_FAILURE = 'REQUEST_PASSWORD_RESET_FAILURE';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_PENDING = 'CHANGE_PASSWORD_PENDING';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
const resetToInitialState = createAction(RESET_TO_INITIAL_STATE);

const requestPasswordReset = createAction(REQUEST_PASSWORD_RESET, username => ({
	promise: api.resetPassword(username),
}));

const changePassword = createAction(CHANGE_PASSWORD, (nonce, password, passwordRepeat) => ({
	promise: api.changePassword(nonce, password, passwordRepeat),
}));

export const actions = {
	resetToInitialState,
	requestPasswordReset,
	changePassword,
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions({
	[RESET_TO_INITIAL_STATE]: () => initialState,
	[REQUEST_PASSWORD_RESET_PENDING]: state => ({
		...state,
		passwordResetRequestFailed: false,
		fetching: true,
	}),
	[CHANGE_PASSWORD_PENDING]: state => ({
		...state,
		fetching: true,
	}),
	[REQUEST_PASSWORD_RESET_SUCCESS]: state => ({
		...state,
		passwordResetRequested: true,
		fetching: false,
	}),
	[REQUEST_PASSWORD_RESET_FAILURE]: state => ({
		...state,
		passwordResetRequested: false,
		passwordResetRequestFailed: true,
		fetching: false,
	}),
	[CHANGE_PASSWORD_SUCCESS]: state => ({
		...state,
		passwordChangeFailed: false,
		fetching: false,
	}),
	[CHANGE_PASSWORD_SUCCESS]: state => ({
		...state,
		passwordChanged: true,
		fetching: false,
	}),
	[CHANGE_PASSWORD_FAILURE]: state => ({
		...state,
		passwordChanged: false,
		passwordChangeFailed: true,
		fetching: false,
	}),
}, initialState);



// WEBPACK FOOTER //
// ./src/redux/modules/password.js